/**
 * Creates a key/value pair in localStorage with an expiration date.
 * @param {String} key   The key of the key/value pair
 * @param {*}      value The value of the key/value pair
 * @param {Number} ttl   "Time to live", in seconds
 */
export default function setWithExpiry(key, value, ttl) {
    const now = new Date();

    // `item` is an object which contains the original value
    // as well as the time when it's supposed to expire
    const item = {
        value: value,
        expiry: now.getTime() + (ttl * 1000)
    };

    localStorage.setItem(key, JSON.stringify(item))
}